export default __webpack_public_path__ + "static/N0025-69b264fc3c04a9f5fd2e2fb23bd83bd2.png";